import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Manager } from '../pages/manager/manager';
import { authPaths, managerPaths } from './manager/manager-paths';
import { RouteGuard } from '../features/route-guard/route-guard';
import { concatPath } from '../helpers/path';
import { Auth } from '../pages/manager/auth/auth';
import { AuthPath, ManagerPath, RootPath } from './manager/manager-enums';

export const routerTree = createBrowserRouter(
  [
    {
      path: RootPath.Manager,
      element: (
        <RouteGuard>
          <Manager />
        </RouteGuard>
      ),
      children: managerPaths,
    },
    {
      path: concatPath([RootPath.Manager, ManagerPath.Auth]),
      element: <Auth />,
      children: authPaths,
    },
    {
      path: '*',
      element: (
        <Navigate to={concatPath([RootPath.Manager, ManagerPath.Auth, AuthPath.Login])} replace />
      ),
    },
  ],
);
